import { Sex } from "./types";

export const WEIGHT_STORAGE_KEY = "saufdings-weight";
export const SEX_STORAGE_KEY = "saufdings-sex";

export const IMPLAUSIBLE_PROMILLE_THRESHOLD = 3;

export const ALCOHOL_DENSITY = 0.789; // g/ml

export const DISTRIBUTION_FACTORS: Record<Sex, number> = {
    male: 0.68,
    female: 0.55,
};

export const ELIMINATION_RATE_PER_HOUR: Record<Sex, number> = {
    male: 0.15,
    female: 0.18,
};

export const DRINKING_DAY_SHIFT_HOURS = 6;
export const DRINKING_DAY_PADDING_MINUTES = 30;
export const DEFAULT_DRINK_DURATION_MINUTES = 30;
export const DATE_TIME_FORMAT = "DD MMM YYYY HH:mm";
export const TIME_INPUT_FORMAT = "HH:mm";
